"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticDataControllerUploadAmenityIconV1PropertyCategoryEnum = exports.StaticDataControllerGetPropertyTypesV1CategoryEnum = exports.StaticDataControllerGetAmenitiesV1CategoryEnum = exports.StaticApi = void 0;
var runtime = __importStar(require("../runtime"));
var index_1 = require("../models/index");
/**
 *
 */
var StaticApi = /** @class */ (function (_super) {
    __extends(StaticApi, _super);
    function StaticApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add bank account
     */
    StaticApi.prototype.staticDataControllerAddBankAccountV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bankAccountCreateDto'] == null) {
                            throw new runtime.RequiredError('bankAccountCreateDto', 'Required parameter "bankAccountCreateDto" was null or undefined when calling staticDataControllerAddBankAccountV1().');
                        }
                        queryParameters = {};
                        if (requestParameters['listingId'] != null) {
                            queryParameters['listingId'] = requestParameters['listingId'];
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        urlPath = "/v1/static/bank-account";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.BankAccountCreateDtoToJSON)(requestParameters['bankAccountCreateDto']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BackAccountResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Add bank account
     */
    StaticApi.prototype.staticDataControllerAddBankAccountV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerAddBankAccountV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Check if app update is required for current version
     */
    StaticApi.prototype.staticDataControllerCheckAppVersionUpdateV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['appVersionCheckRequestDto'] == null) {
                            throw new runtime.RequiredError('appVersionCheckRequestDto', 'Required parameter "appVersionCheckRequestDto" was null or undefined when calling staticDataControllerCheckAppVersionUpdateV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        urlPath = "/v1/static/app-version/check";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.AppVersionCheckRequestDtoToJSON)(requestParameters['appVersionCheckRequestDto']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AppVersionCheckResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Check if app update is required for current version
     */
    StaticApi.prototype.staticDataControllerCheckAppVersionUpdateV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerCheckAppVersionUpdateV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete active bank account of a listing
     */
    StaticApi.prototype.staticDataControllerDeleteBankAccountV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['listingId'] == null) {
                            throw new runtime.RequiredError('listingId', 'Required parameter "listingId" was null or undefined when calling staticDataControllerDeleteBankAccountV1().');
                        }
                        queryParameters = {};
                        if (requestParameters['listingId'] != null) {
                            queryParameters['listingId'] = requestParameters['listingId'];
                        }
                        headerParameters = {};
                        urlPath = "/v1/static/bank-account";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ModelApiResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete active bank account of a listing
     */
    StaticApi.prototype.staticDataControllerDeleteBankAccountV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerDeleteBankAccountV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get amenities by property category
     */
    StaticApi.prototype.staticDataControllerGetAmenitiesV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['category'] == null) {
                            throw new runtime.RequiredError('category', 'Required parameter "category" was null or undefined when calling staticDataControllerGetAmenitiesV1().');
                        }
                        queryParameters = {};
                        if (requestParameters['category'] != null) {
                            queryParameters['category'] = requestParameters['category'];
                        }
                        headerParameters = {};
                        urlPath = "/v1/static/amenities";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AmenitiesResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get amenities by property category
     */
    StaticApi.prototype.staticDataControllerGetAmenitiesV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerGetAmenitiesV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all app version details
     */
    StaticApi.prototype.staticDataControllerGetAppVersionsV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        urlPath = "/v1/static/app-version";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AppVersionListResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all app version details
     */
    StaticApi.prototype.staticDataControllerGetAppVersionsV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerGetAppVersionsV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get active bank account
     */
    StaticApi.prototype.staticDataControllerGetBankAccountV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['listingId'] != null) {
                            queryParameters['listingId'] = requestParameters['listingId'];
                        }
                        headerParameters = {};
                        urlPath = "/v1/static/bank-account";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BackAccountResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get active bank account
     */
    StaticApi.prototype.staticDataControllerGetBankAccountV1 = function () {
        return __awaiter(this, arguments, void 0, function (requestParameters, initOverrides) {
            var response;
            if (requestParameters === void 0) { requestParameters = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerGetBankAccountV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get global masked marketing phone numbers
     */
    StaticApi.prototype.staticDataControllerGetMaskedMarketingNumbersV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        urlPath = "/v1/static/marketing/masked-numbers";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.MaskedMarketingNumbersResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get global masked marketing phone numbers
     */
    StaticApi.prototype.staticDataControllerGetMaskedMarketingNumbersV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerGetMaskedMarketingNumbersV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get property types by category
     */
    StaticApi.prototype.staticDataControllerGetPropertyTypesV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['category'] == null) {
                            throw new runtime.RequiredError('category', 'Required parameter "category" was null or undefined when calling staticDataControllerGetPropertyTypesV1().');
                        }
                        queryParameters = {};
                        if (requestParameters['category'] != null) {
                            queryParameters['category'] = requestParameters['category'];
                        }
                        headerParameters = {};
                        urlPath = "/v1/static/property-types";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.PropertyTypesResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get property types by category
     */
    StaticApi.prototype.staticDataControllerGetPropertyTypesV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerGetPropertyTypesV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get suburbs suggestions
     */
    StaticApi.prototype.staticDataControllerGetSuburbsSuggestionsV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['keyword'] == null) {
                            throw new runtime.RequiredError('keyword', 'Required parameter "keyword" was null or undefined when calling staticDataControllerGetSuburbsSuggestionsV1().');
                        }
                        queryParameters = {};
                        if (requestParameters['keyword'] != null) {
                            queryParameters['keyword'] = requestParameters['keyword'];
                        }
                        headerParameters = {};
                        urlPath = "/v1/static/suburbs/suggest";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.SuburbsSuggestionsResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get suburbs suggestions
     */
    StaticApi.prototype.staticDataControllerGetSuburbsSuggestionsV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerGetSuburbsSuggestionsV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Receive inbound email from SendGrid
     */
    StaticApi.prototype.staticDataControllerReceiveInboundEmailV1Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        urlPath = "/v1/static/webhooks/sendgrid/inbound";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ModelApiResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Receive inbound email from SendGrid
     */
    StaticApi.prototype.staticDataControllerReceiveInboundEmailV1 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerReceiveInboundEmailV1Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Set global masked marketing phone numbers
     */
    StaticApi.prototype.staticDataControllerSetMaskedMarketingNumbersV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['maskedMarketingNumbersDto'] == null) {
                            throw new runtime.RequiredError('maskedMarketingNumbersDto', 'Required parameter "maskedMarketingNumbersDto" was null or undefined when calling staticDataControllerSetMaskedMarketingNumbersV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        urlPath = "/v1/static/marketing/masked-numbers";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.MaskedMarketingNumbersDtoToJSON)(requestParameters['maskedMarketingNumbersDto']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.MaskedMarketingNumbersResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Set global masked marketing phone numbers
     */
    StaticApi.prototype.staticDataControllerSetMaskedMarketingNumbersV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerSetMaskedMarketingNumbersV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Upload amenity icon to public bucket
     */
    StaticApi.prototype.staticDataControllerUploadAmenityIconV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['propertyCategory'] == null) {
                            throw new runtime.RequiredError('propertyCategory', 'Required parameter "propertyCategory" was null or undefined when calling staticDataControllerUploadAmenityIconV1().');
                        }
                        if (requestParameters['groupName'] == null) {
                            throw new runtime.RequiredError('groupName', 'Required parameter "groupName" was null or undefined when calling staticDataControllerUploadAmenityIconV1().');
                        }
                        if (requestParameters['file'] == null) {
                            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling staticDataControllerUploadAmenityIconV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        consumes = [
                            { contentType: 'multipart/form-data' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        // use FormData to transmit files using content-type "multipart/form-data"
                        useForm = canConsumeForm;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters['propertyCategory'] != null) {
                            formParams.append('propertyCategory', requestParameters['propertyCategory']);
                        }
                        if (requestParameters['groupName'] != null) {
                            formParams.append('groupName', requestParameters['groupName']);
                        }
                        if (requestParameters['icon'] != null) {
                            formParams.append('icon', requestParameters['icon']);
                        }
                        if (requestParameters['file'] != null) {
                            formParams.append('file', requestParameters['file']);
                        }
                        urlPath = "/v1/static/amenities/icon";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AmenityIconUploadResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Upload amenity icon to public bucket
     */
    StaticApi.prototype.staticDataControllerUploadAmenityIconV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerUploadAmenityIconV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create or update app version details for platform
     */
    StaticApi.prototype.staticDataControllerUpsertAppVersionV1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, urlPath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['appVersionDto'] == null) {
                            throw new runtime.RequiredError('appVersionDto', 'Required parameter "appVersionDto" was null or undefined when calling staticDataControllerUpsertAppVersionV1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        urlPath = "/v1/static/app-version";
                        return [4 /*yield*/, this.request({
                                path: urlPath,
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.AppVersionDtoToJSON)(requestParameters['appVersionDto']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AppVersionResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create or update app version details for platform
     */
    StaticApi.prototype.staticDataControllerUpsertAppVersionV1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.staticDataControllerUpsertAppVersionV1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return StaticApi;
}(runtime.BaseAPI));
exports.StaticApi = StaticApi;
/**
 * @export
 */
exports.StaticDataControllerGetAmenitiesV1CategoryEnum = {
    Residential: 'residential',
    Commercial: 'commercial',
    Business: 'business',
    Rural: 'rural',
    Land: 'land'
};
/**
 * @export
 */
exports.StaticDataControllerGetPropertyTypesV1CategoryEnum = {
    Residential: 'residential',
    Rural: 'rural',
    Land: 'land'
};
/**
 * @export
 */
exports.StaticDataControllerUploadAmenityIconV1PropertyCategoryEnum = {
    Residential: 'residential',
    Commercial: 'commercial',
    Business: 'business',
    Rural: 'rural',
    Land: 'land'
};
